import { render, staticRenderFns } from "./AbcCollectionComponent.vue?vue&type=template&id=2df758a2"
import script from "./AbcCollectionComponent.vue?vue&type=script&lang=js"
export * from "./AbcCollectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AbcCollectionComponent.vue?vue&type=custom&index=0&blockType=stile&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports